"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPricingDetails = getPricingDetails;
var _common = require("./common");
function getPricingDetails(url, token, adId) {
  if (!adId) {
    return Promise.reject();
  }
  var requestUrl = "".concat(url, "?ad_id=").concat(adId);
  var options = {
    method: 'GET',
    mode: 'cors',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'x-access-token': token
    },
    credentials: 'include'
  };
  return (0, _common.request)(requestUrl, options);
}